import { exists } from '@/helpers'
import { EventStatus, type LiveEvent } from '@setplex/tria-api'
import {
  DATE_FORMATS,
  formatDateDuration,
  formatStartTime,
  timeWithin,
} from '~/shared/helpers/date'
import type { EventWithPrice } from '~/shared/interfaces'

export const formatLiveEventWithPrice = (liveEvent: LiveEvent) => {
  const withPrice: EventWithPrice = {
    ...liveEvent,
    formattedStartTime:
      exists(liveEvent.startTime) && liveEvent.status === EventStatus.SOON
        ? formatStartTime(
            liveEvent.startTime,
            DATE_FORMATS.MMM_DD_YYYY_HH_MM_LOCALIZED
          )
        : undefined,
    labelPrice: liveEvent.purchaseInfo
      ? ''
      : `${liveEvent.minCurrency} ${liveEvent.minPrice}`,
  }

  return withPrice
}

export const formatPastEventWithPrice = (liveEvent: LiveEvent) => {
  const duration =
    exists(liveEvent.startTime) && exists(liveEvent.endTime)
      ? timeWithin(new Date(liveEvent.endTime), new Date(liveEvent.startTime))
      : undefined

  const withPrice: EventWithPrice = {
    ...formatLiveEventWithPrice(liveEvent),
    formattedStartTime: duration
      ? formatDateDuration({
          duration,
          short: true,
        })
      : undefined,
  }

  return withPrice
}
